import { SEO } from "@/components/seo/SEO";
import { PricingPlans } from "@/components/subscription/PricingPlans";
import { generateBreadcrumbSchema, generateProductSchema } from "@/lib/seoSchemas";

const Pricing = () => {
  const origin = typeof window !== "undefined" ? window.location.origin : "";
  
  const schemas = [
    generateBreadcrumbSchema([
      { name: "Home", path: "/" },
      { name: "Pricing", path: "/pricing" }
    ], origin),
    generateProductSchema(
      "Medical Student MCQ Subscription - Monthly Plan",
      "Access to comprehensive medical MCQ question bank with detailed explanations, progress tracking, and mock exams.",
      "9.99"
    ),
    generateProductSchema(
      "SMLE Preparation - Monthly Plan", 
      "Saudi Medical Licensing Exam preparation with 7,600+ practice questions and detailed explanations.",
      "50.00"
    )
  ];

  return (
    <>
      <SEO 
        title="Pricing Plans - Medical Exam Subscriptions | QuickMedicalReview"
        description="Medical exam prep plans starting at $9.99/month (USD) or 50 SAR/month. 10,000+ MCQs for Medical Students and SMLE. 3-day free trial included."
        path="/pricing"
        keywords="medical mcq pricing, medical student subscription, smle subscription, medical exam prep cost, saudi medical licensing exam"
        schema={schemas}
      />
      
      <div className="container py-8">
        <PricingPlans />
      </div>
    </>
  );
};

export default Pricing;